/*
 * Reusable 'rules' for validating Vuetify form fields using the 'rules' prop.
 *
 * Each functions receives the current 'v-model' value as an argument and must return
 * either true / false or a string containing an error message.
 */

//
// A required field must have at lease one non-blank character.
//
const required = (value) => !!(value.trim()) || 'Required.';

export default { required };
